export const getUserFullName = (userFirstName, userLastName) => `${userFirstName || ''} ${userLastName || ''}`;

export const getUserInitials = (userFirstName, userLastName) => {
  const firstNameArray = (userFirstName || '').split(' ');
  const lastNameArray = (userLastName || '').split(' ');
  const userNameArray = [...firstNameArray, ...lastNameArray];

  const charLimit = 3;

  return userNameArray
    .filter(Boolean)
    .map(name => name[0].toUpperCase()).join('').substring(0, charLimit);
};
